// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4683":"3c9d27ba","5429":"c3f008d3","8789":"35548057","9024":"8e597dab","9390":"35548057"}[chunkId] + ".chunk.css";
};